import { render, staticRenderFns } from "./ModalMoveNaungan.vue?vue&type=template&id=1a3dc4fd"
import script from "./ModalMoveNaungan.vue?vue&type=script&lang=js"
export * from "./ModalMoveNaungan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports